import Page from "./Page";
import App from "./App";
import logo_src from "./resources/logo.png";
import tree_src from "./resources/trees/tree8.svg";

export { App, Page, logo_src, tree_src };

export default App;



// WEBPACK FOOTER //
// ./src/app/index.js